import { useCallback, useEffect, useState } from 'react';
import { api, type Track } from '../../api.js';

const POLL_INTERVAL_MS = 30_000;

export function useTracks(): {
  tracks: Track[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
} {
  const [tracks, setTracks] = useState<Track[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const r = await api.listTracks();
      setTracks(r.tracks);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [load]);

  return { tracks, loading, error, refresh: load };
}
